var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMilestoneArrowRight = function SvgMilestoneArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1064 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1 3.498a.5.5 0 1 0 0 1zm1062.35.854c.2-.196.2-.512 0-.708l-3.18-3.181a.503.503 0 0 0-.71 0 .51.51 0 0 0 0 .707l2.83 2.828-2.83 2.828a.51.51 0 0 0 0 .708c.2.195.52.195.71 0zM1 3.998v.5h1062v-1H1z"
  })));
};
export default SvgMilestoneArrowRight;